import React, {Component} from "react";
import SimpleReactValidator from "simple-react-validator";

/* Import Components */
import Input from "./Input";
import TextArea from "./TextArea";
import Button from "./Button";
import RadioButton from "./RadioButton";
import EmailInput from "./EmailInput";
import TelephoneInput from "./TelephoneInput";
import Confirmation from "./Confirmation";
import ChildrenForm from "./ChildrenForm";
import ResearchDisclaimer from "./ResearchDisclaimer";
import CheckBox from "./CheckBox";

import FetchHelper from "./helpers/FetchHelper";
import CheckBox from "./CheckBox";

class FormContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialState: true,
            loading: false,
            submitted: false,
            newUser: {},
            localAuthorityOptions: props.localAuthorityOptions || [],
            methodOfSupportOptions: props.methodOfSupportOptions || [],
            genderOptions: props.genderOptions || [],
            yesNoOptions: ["Yes", "No"],
            parentsLiveTogetherOptions: [
                { id: true, description: "Parents living together" }, 
                { id: false, description: "Parents separated" }
            ],
            referralTypeOptions: ["Self referral", "On behalf of parent"],
            schoolOptions: props.schoolOptions || [],
            schoolYearOptions: props.schoolYearOptions || [],
            concernLevelOptions: props.concernLevelOptions || [],
            familyDifficultyOptions: props.familyDifficultyOptions || [],
            parentCarerOptions: props.parentCarerOptions || [],
        };

        const validateNumber = (phone_number) => {
            if (!phone_number || phone_number?.length === 0) {
                return {
                    valid: true,
                    message: "phone number not required"
                }
            } else {
                if (phone_number?.startsWith('07') || phone_number?.startsWith('+44')) {
                    let numberLength = phone_number.length || 0
                    if (phone_number?.startsWith('0')) {
                        if (numberLength !== 11) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (0) must be 11 characters, currently ${numberLength} chars.`
                            }
                        }
                    }
                    if (phone_number?.startsWith('+44')) {
                        if (numberLength !== 13) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (+44) must be 13 characters, currently ${numberLength} chars`
                            }
                        }
                    }
                    if (!phone_number?.match(/^[+0-9]*$/)) {
                        return {
                            valid: false,
                            message: "A phone number can only have numbers or +"
                        }
                    }
                } else {
                    return {
                        valid: false,
                        message: `UK phone number must start with either (+44) or (07)`
                    }
                }
            }
            return {
                valid: true,
            }
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: "en",
            className: "text-danger",
            validators: {
                custom_phone_number: {
                    message: ':replaced',
                    rule: (val, params, validator) => {
                        return validateNumber(val).valid
                    },
                    messageReplace: (message, params) => {
                        return validateNumber(params[0]).message
                    },  // optional
                }
            }
        });
    }

    renderErrorPage = () => {
        window.location.assign("/500.html");
    };

    handleInputChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: value
            }
        }));
    };

    handleCheckBox = e => {
        const {name, value} = e.target;
        const {newUser} = this.state;
        let values = newUser[name] || [];
        if (values.indexOf(value) > -1) {
            values = values.filter(s => s !== value);
        } else {
            values.push(value);
        }

        this.setState(prevState => ({
            newUser: {...prevState.newUser, [name]: values}
        }));
    };

    handleFormSubmit = e => {
        e.preventDefault();

        const {csrfToken, parentDomain} = this.props;
        let userData = this.state.newUser;

        this.setState({initialState: false});

        if ((userData.children || []).length === 0) {
            this.validator.showMessages();
            return;
        }

        if (userData.referralType !== 'On behalf of parent') {
            delete userData.referrerEmail;
            delete userData.referrerName;
            delete userData.referralRelationship;
        }

        FetchHelper.fetchWithPost({
            context: this,
            csrfToken,
            parentDomain,
            type: "exchange_parent",
            body: userData
        });
    };

    handleCheckBox = e => {
        const {name, value} = e.target;
        const {newUser} = this.state;
        let values = newUser[name] || [];
        if (values.indexOf(value) > -1) {
            values = values.filter(s => s !== value);
        } else {
            values.push(value);
        }

        this.setState(prevState => ({
            newUser: {...prevState.newUser, [name]: values}
        }));
    };

    handleChildrenChange = (children) => {
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                children
            }
        }))
    };

    validChildren = () => {
        const {initialState, newUser: { children = [] }} = this.state;
        return initialState || children.length > 0
    }

    isValid = () => {
        const {initialState} = this.state;
        return initialState || (this.validator.allValid() && this.validChildren())
    }

    renderSubmitButton = () => {
        const { loading } = this.state
        const valid = this.isValid()
        return (
            <>
                {!valid && (
                    <div className="alert alert-danger">
                        There are unresolved form errors, please correct the form before
                        resubmitting.
                    </div>
                )}
                <Button
                    type="submit"
                    className="btn-primary"
                    disabled={!valid || loading}
                >
                    Submit
                </Button>
            </>
        );
    };

    render() {
        const {
            dateOfBirth,
            firstName,
            lastName,
            emailAddress,
            phoneNumber,
            address1,
            address2,
            address3,
            address4,
            postcode,
            gender,
            methodOfSupport,
            howChildIsStruggling,
            whatSupportOrIntervention,
            importantFamilyLifeEvents,
            familyHasDifficulty,
            parentsLiveTogether,
            statutorySupport,
            referrerName,
            referrerEmail,
            referralRelationship,
            referralType,
            parentCarer,
            exchangeParentConfirmation,
        } = this.state.newUser;

        const {
            submitted,
            localAuthorityOptions,
            methodOfSupportOptions,
            genderOptions,
            parentsLiveTogetherOptions,
            schoolOptions,
            schoolYearOptions,
            concernLevelOptions,
            referralTypeOptions,
            familyDifficultyOptions,
            parentCarerOptions,
        } = this.state;

        // ensure conditional fields are validated properly
        // https://www.npmjs.com/package/simple-react-validator#3-conditional-fields
        this.validator.purgeFields();

        return (
            <div className="container">
                <h1>
                    The-Exchange Parent
                    <small>Referrals for counselling and psychological support</small>
                </h1>
                {submitted ? (
                    <Confirmation
                        referralType="Exchange Parent"
                        returnCallback={() => {
                            this.setState({
                                submitted: false,
                                newUser: {},
                                initialState: true
                            });
                        }}
                    />
                ) : (
                    <form className="row" onSubmit={this.handleFormSubmit} noValidate>
                        <div className="col-8">
                            <div className="alert alert-secondary">
                                <p>
                                    Fields marked with <span className="required-field">*</span>
                                    are mandatory.
                                </p>
                            </div>
                            <h2>Parent details</h2>
                            <div className="form-group">
                                <Input
                                    label="First name"
                                    name="firstName"
                                    value={firstName}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "first name",
                                    firstName,
                                    "required|alpha_space"
                                )}
                            </div>
                            <div className="form-group">
                                <Input
                                    label="Last name"
                                    name="lastName"
                                    value={lastName}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "last name",
                                    lastName,
                                    "required|alpha_space"
                                )}
                            </div>
                            <h4>Address</h4>
                            <div className="form-group">
                                <Input
                                    name="address1"
                                    label="Line 1"
                                    value={address1}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message("address line 1", address1, "required")}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address2"
                                    label="Line 2"
                                    value={address2}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address3"
                                    label="Line 3"
                                    value={address3}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address4"
                                    label="Line 4"
                                    value={address4}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="postcode"
                                    label="Postcode"
                                    value={postcode}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "postcode",
                                    postcode,
                                    "required|alpha_num_space"
                                )}
                            </div>
                            <div className="form-group">
                                <TelephoneInput
                                    name="phoneNumber"
                                    label={"Phone number"}
                                    value={phoneNumber}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "phone number",
                                    phoneNumber,
                                    `required|custom_phone_number:${phoneNumber}`,
                                )}
                            </div>
                            <div className="form-group">
                                <EmailInput
                                    label={"Email address"}
                                    name="emailAddress"
                                    id="emailAddress"
                                    value={emailAddress}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message("email address", emailAddress, "required|email")}
                            </div>

                            <div className="form-group">
                                <Input
                                    name="dateOfBirth"
                                    label="Date of birth (DD/MM/YYYY)"
                                    value={dateOfBirth}
                                    required={true}
                                    type="date"
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "date of birth",
                                    dateOfBirth,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="Gender"
                                    name="gender"
                                    options={genderOptions}
                                    value={gender}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />
                                {this.validator.message("gender", gender, "required")}
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="What support are you looking for?"
                                    name="methodOfSupport"
                                    options={methodOfSupportOptions}
                                    value={methodOfSupport}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="Are you a parent carer?"
                                    name="parentCarer"
                                    options={parentCarerOptions}
                                    value={parentCarer}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="col-10">
                            <h2>The family</h2>                            
                            <div className="form-group">
                                <TextArea
                                    name="howChildIsStruggling"
                                    label="How your child / children are struggling?"
                                    value={howChildIsStruggling}
                                    maxLength={800}
                                    onChange={this.handleInputChange}
                                />
                            </div>                            
                            <div className="form-group">
                                <TextArea
                                    name="whatSupportOrIntervention"
                                    label="What support / interventions has your child/children received in school?"
                                    value={whatSupportOrIntervention}
                                    maxLength={300}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <TextArea
                                    name="importantFamilyLifeEvents"
                                    label="Are there any important events in the family's life we should be aware of?"
                                    value={importantFamilyLifeEvents}
                                    maxLength={300}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group ">
                                <CheckBox
                                    name="familyHasDifficulty"
                                    label="Does anyone in the family have: Physical Disabilities / Learning Difficulties / Mental Difficulties / Financial?"
                                    onChange={this.handleCheckBox}
                                    options={familyDifficultyOptions}
                                    selectedOptions={familyHasDifficulty}
                                />
                            </div>
                            <div className="form-group ">
                                <RadioButton
                                    label="Are the parents living together / parents separated?"
                                    name="parentsLiveTogether"
                                    options={parentsLiveTogetherOptions}
                                    value={parentsLiveTogether}
                                    onChange={this.handleInputChange}
                                    required
                                />
                                {this.validator.message(
                                    "parents living together / parents separated",
                                    parentsLiveTogether,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                <TextArea
                                    name="statutorySupport"
                                    label="Is the family being supported by any other Statutory Service?"
                                    value={statutorySupport}
                                    maxLength={200}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="Referrer"
                                    name="referralType"
                                    options={referralTypeOptions}
                                    value={referralType}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message(
                                    "referrer",
                                    referralType,
                                    "required"
                                )}
                            </div>

                            {referralType && referralType === "On behalf of parent" && (
                                <>
                                    <div className="form-group">
                                        <EmailInput
                                            label={"Referrer's email address"}
                                            name="referrerEmail"
                                            id="referrerEmail"
                                            value={referrerEmail}
                                            required={true}
                                            onChange={this.handleInputChange}
                                        />
                                        {this.validator.message(
                                            "referrer's email address", 
                                            referrerEmail, 
                                            "required|email"
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <Input
                                            label="Referrer's name"
                                            name="referrerName"
                                            value={referrerName}
                                            required={true}
                                            onChange={this.handleInputChange}
                                        />{" "}
                                        {this.validator.message(
                                            "referrer's name",
                                            referrerName,
                                            "required"
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <Input
                                            label="Relationship to person referred"
                                            name="referralRelationship"
                                            value={referralRelationship}
                                            required={true}
                                            onChange={this.handleInputChange}
                                        />{" "}
                                        {this.validator.message(
                                            "relationship to person referred",
                                            referralRelationship,
                                            "required"
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="col-12">
                            <h2>Children</h2>
                            {!this.validChildren() && (  
                                <p class="text-danger">Please add at least one child to the referral.</p>
                            )}
                            <ChildrenForm 
                                localAuthorities={localAuthorityOptions}
                                schools={schoolOptions}
                                schoolYears={schoolYearOptions}
                                concernLevels={concernLevelOptions}
                                genders={genderOptions}
                                onChange={this.handleChildrenChange}
                            />

                            <div className="form-group">
                                <CheckBox
                                    label="
                    This statement is for those who are accessing our services for themselves
                    or on behalf of another person (i.e. making a referral) If you are accessing
                    the services for yourself, please read this statement because it sets out what
                    you are consenting to. If you are referring someone to receive confidential support
                    please read and confirm. To process this referral and put in place psychological wellbeing
                    support, the organisation requires the information which is to be entered into the referral form.
                    This is personal information covered under the GDPR regulations and therefore it is a requirement
                    that the person who is being referred has consented to the personal information being shared with this
                    organisation. The data is confidential and not shared with others, but we retain the right to use this
                    information to contact others if we believe the person receiving our support (or others) is in danger or
                    at risk of abuse. As far as possible we will seek consent before taking this action, but the safety of
                    those we support is our priority.
                "
                                    helpText="If the support is for you then it is necessary to confirm that you
                    understand this statement. If the referral is being made on behalf of another, then the person making
                    the referral must confirm that the consent of the person has been sought and received."
                                    name="exchangeParentConfirmation"
                                    options={["I agree"]}
                                    selectedOptions={exchangeParentConfirmation}
                                    onChange={this.handleCheckBox}
                                    required={true}
                                />
                                {this.validator.message(
                                    "agreement",
                                    exchangeParentConfirmation,
                                    "required"
                                )}
                            </div>
                            {this.renderSubmitButton()}
                        </div>
                            <ResearchDisclaimer />
                    </form>
                )}
            </div>
        );
    }
}

export default FormContainer;
